export const NETWORK = {
  path: 'network',
  redirect: { name: 'network' },
  meta: {
    title: 'recruiter_network.meta.title'
  },
  children: [
    {
      path: '',
      name: 'network',
      meta: {
        title: 'recruiter_network.meta.title'
      },
      component: () => import('@/views/recruiter/ContactsTableView.vue')
    },
    {
      path: 'invite',
      name: 'network-invite',
      meta: {
        title: 'recruiter_network.meta.invite'
      },
      component: () => import('@/views/recruiter/network/NetworkView.vue')
    }
  ]
};
